<template>
  <div class="drag2" :hidden="!ifShow">
    <el-form :inline="true" :model="businessData" :rules="formRules" ref="businessDataForm" label-width="100px">
      <el-row type="flex" justify="center">
        <el-form-item label="节点code" prop="code">
          <el-input v-model="businessData.nodeCode" style="width: 270px" @blur="saveNodeData" :disabled="codeEditable"></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="center">
        <el-form-item label="节点名称" prop="name">
          <el-input v-model="businessData.nodeName" style="width: 270px" @blur="saveNodeData"></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="left">
        <el-tabs v-model="activeMiddleTabName" type="card" @tab-click="handleTabClick">
          <el-tab-pane label="规则" name="first">
            <el-row type="flex" justify="left">
              <el-col>
                <el-button type="primary" @click="handleRulesChange">{{ifRulesShow ? '绑定' : '编辑'}}</el-button>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-select v-model="values" multiple placeholder="请选择" style="margin: 0 0 0 3px;width: 250px" filterable v-if="ifRulesShow">
                    <el-option v-for="(item, i) in rules" :key="i" :label="`${item.code}-${item.name}`" :value="item.code"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="left" v-for="(item, i) in targetRules" :key="i">
              <el-form-item :label="item.name">
                <el-input v-model="item.code" disabled style="width: 250px"></el-input>
                <el-button icon="el-icon-delete" @click="removeRule(item, i)" type="text" style="color: #F56C6C"/>
              </el-form-item>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="赋值" name="second">
            <el-row type="flex" justify="left">
              <el-button type="primary" class="el-icon-plus" @click="addEvaluation"/>
              <el-button type="primary" @click="saveEvaluations">保存</el-button>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top: 5px" v-for="(item, i) in evaluations" :key="i">
              <el-select v-model="item.name" clearable placeholder="请选择" style="width: 35%">
                <el-option v-for="(item, i) in variables" :key="i" :label="item.name" :value="item.name"></el-option>
              </el-select>
              <el-button>=</el-button>
              <!--<el-input v-model="item.viewData" placeholder="输出值" clearable style="width: 55%"></el-input>-->
              <tribute-mention :ref="`evaluation-${item.name}`" :value.sync="item.viewData" :sources="variableSources"></tribute-mention>
              <el-button icon="el-icon-delete" @click="removeEvaluation(item, i)" type="text" style="color: #F56C6C"/>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="分流" name="third">
            <el-button type="primary" @click="saveShunts" style="margin-bottom: 5px">保存</el-button>
            <el-table ref="shuntsTable" id="shuntsTable" :data="shunts" border stripe highlight-current-row style="width: 376px;">
              <el-table-column label="分流" width="100" header-align="center">
                <template slot-scope="scope">
                  <i class="el-icon-rank drag-handler" />
                  <span class="drag-handler">{{scope.row.diversionGraphicNodeCode}}</span>
                </template>
              </el-table-column>
              <el-table-column label="条件" header-align="center">
                <template slot-scope="scope">
                  <span v-if="scope.$index === shunts.length - 1">{{scope.row.viewData}}</span>
                  <tribute-mention :ref="`shunt-${scope.row.diversionGraphicNodeId}`" v-else :value.sync="scope.row.viewData" :sources="variableSources"></tribute-mention>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Editable from '@/components/editable/Editable.vue'
import EditableColumn from '@/components/editable/EditableColumn.vue'
import TributeMention from '@/components/mention/tributeMention.vue'
import Sortable from 'sortablejs'
import debounce from 'throttle-debounce/debounce'
import {loadMentionSources} from '@/utils/common'

export default {
  props: {
    ifShow: Boolean,
    variablesData: Array,
    nodeData: Object
  },
  data () {
    return {
      regex: new RegExp(`(?<=@)[sme].[a-zA-Z\\d_.]+(?=\\s)`, 'g'),
      editable: false,
      codeEditable: false,
      rules: [],
      targetRules: [],
      variables: [],
      evaluations: [],
      shunts: [],
      businessData: {
        id: 0,
        graphicNodeId: '',
        nodeCode: '',
        nodeName: '',
        strategyCode: '',
        strategyName: '',
        strategyVersion: '',
        inputConfig: '',
        rules: [],
        evaluations: [],
        shunts: []
      },
      formRules: {},
      ifRulesShow: false,
      values: [],
      activeMiddleTabName: 'first',
      variableSources: []
    }
  },
  watch: {
    nodeData: {
      deep: true,
      async handler (value) {
        if (!this.editable) {
          this.codeEditable = value.business.nodeCode !== 'new node code'
          this.businessData = this.$utils.clone(value.business, true)
          this.variableSources = await loadMentionSources.doLoadAllSources(this.businessData.strategyId)
          this.loadRules()
          this.editable = true
        }
      }
    },
    variablesData: {
      deep: true,
      handler (value) {
        this.variables = this.$utils.clone(value, true)
      }
    }
  },
  methods: {
    handleRulesChange () {
      if (this.ifRulesShow) {
        this.saveRules()
      } else {
        this.ifRulesShow = !this.ifRulesShow
      }
    },
    // ********************  保存节点数据  *******************
    async saveNodeData () {
      console.info('saveNodeData', this.businessData)
      this.businessData.code = this.businessData.nodeCode
      this.businessData.name = this.businessData.nodeName
      if (this.businessData.nodeCode === 'new node code') {
        this.$message.error('节点名称不能为默认值')
        return
      }
      // 请求后端服务
      let nodeInfo = await this.loadNodeInfo()
      try {
        let res = await (nodeInfo ? this.$http.put(`/strategy-node/alias`, this.businessData)
          : this.$http.post(`/strategy-node/alias`, this.businessData))
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.codeEditable = true
        this.saveNodesData()
        this.$message.success('节点code/名称保存成功')
      } catch (ex) {
        console.info(ex)
        this.$message.error('节点code/名称保存成功')
      }
    },
    // ********************  tabs切换  *******************
    handleTabClick () {
      console.info('handleTabClick', this.activeMiddleTabName)
      this.initNodeData()
      if (this.activeMiddleTabName === 'first') this.loadRules()
      if (this.activeMiddleTabName === 'second') this.loadEvaluations()
      if (this.activeMiddleTabName === 'third') this.loadShunts()
    },
    initNodeData () {
      this.codeEditable = this.businessData.nodeCode !== 'new node code'
      this.rules = []
      this.targetRules = []
      this.evaluations = []
      this.shunts = []
    },
    // ********************  规则  ***********************
    async loadRules () {
      try {
        let res = await this.$http.get(`/strategy/${this.businessData.strategyId}/rule-list`)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.rules = res.data
      } catch (ex) {
        console.info(ex)
        this.$message.error('获取策略下的所有规则失败')
      }
      try {
        let res = await this.$http.get(`/strategy/${this.businessData.strategyId}/${this.businessData.graphicNodeId}/graphic-node-item`)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.targetRules = res.data
      } catch (ex) {
        console.info(ex)
        this.$message.error('获取策略下该节点的所有规则失败')
      }
    },
    saveRules: debounce(300, async function () {
      console.info('saveRules', this.values)
      // 请求后端服务
      this.loadRules()
      let tmpRules = []
      try {
        this.values.forEach((item, i) => {
          let exist = this.targetRules.find(o => item === o.code)
          let rule = this.rules.find(s => item === s.code)
          if (!exist && rule) {
            tmpRules.push(rule)
          }
        })
        if (tmpRules.length === 0) {
          this.reloadRules()
          this.$message.success('保存成功')
          return
        }
        tmpRules.forEach((item, i) => {
          item.strategyId = this.businessData.strategyId
          item.graphicNodeId = this.businessData.graphicNodeId
          item.strategyItemId = item.id
        })
        let res = await this.$http.post(`/strategy/node-item`, tmpRules)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.reloadRules()
        this.$message.success('保存成功')
      } catch (ex) {
        console.info(ex)
        this.$message.error('保存失败')
      }
    }),
    reloadRules () {
      this.loadRules()
      this.businessData.rules = this.$utils.clone(this.targetRules, true)
      this.values = []
      this.saveNodesData()
      this.ifRulesShow = !this.ifRulesShow
    },
    removeRule: debounce(300, async function (row, index) {
      console.info('removeRule', row)
      this.$confirm('确认删除吗？', '提示', {type: 'warning'}).then(async () => {
        try {
          console.info('removeRule', row)
          if (!row.id) {
            this.loadRules()
            this.$message.success('删除成功!')
            return
          }
          let res = await this.$http.delete(`/strategy/node-item/${row.id}`)
          if (res.code !== '200') {
            this.$message.error(res.message)
            return
          }
          this.loadRules()
          this.$message.success('删除成功')
        } catch (ex) {
          console.info(ex)
          this.$message.error('删除失败')
        }
      }).catch(action => {
      })
    }),
    // ********************  赋值  ***********************
    addEvaluation () {
      this.evaluations.push({
        strategyId: this.businessData.strategyId,
        graphicNodeId: this.businessData.graphicNodeId,
        name: '',
        expression: '',
        viewData: ''
      })
    },
    async loadEvaluations () {
      console.info('loadEvaluations', this.businessData)
      try {
        let params = {
          strategyId: this.businessData.strategyId,
          graphicNodeId: this.businessData.graphicNodeId
        }
        let res = await this.$http.post(`/strategy-node-variable/list`, params)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.evaluations = res.data
      } catch (ex) {
        console.info(ex)
        this.$message.error('获取策略节点变量失败')
      }
    },
    saveEvaluations: debounce(300, async function () {
      console.info('saveEvaluations')
      // 请求后端服务
      try {
        let checkRes = this.checkStrategyVariable()
        if (checkRes) {
          this.$message.error('赋值数据不完整，请补充！')
          return
        }
        this.handleStrategyVariable()
        let res = await this.$http.post(`/strategy-node-variable`, this.evaluations)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.loadEvaluations()
        this.businessData.evaluations = this.$utils.clone(this.evaluations, true)
        this.saveNodesData()
        this.$message.success('保存成功')
      } catch (ex) {
        console.info(ex)
        this.$message.error('保存失败')
      }
    }),
    checkStrategyVariable () {
      return this.evaluations.some((item, i) => item.name === null || (item.viewData === null || item.viewData === ''))
    },
    handleStrategyVariable () {
      this.evaluations.forEach((item, i) => {
        item.sequence = i + 1
        item.expression = this.getExpression(item.viewData, item.name)

        item.strategyRefVariables = this.getStrategyRefVariables(`evaluation-${item.name}`, 2)
      })
      console.info('handleStrategyVariable', this.evaluations)
    },
    removeEvaluation: debounce(300, async function (row, index) {
      this.$confirm('确认删除吗？', '提示', {type: 'warning'}).then(async () => {
        try {
          if (!row.id) {
            this.loadEvaluations()
            this.$message.success('删除成功!')
            return
          }
          let res = await this.$http.delete(`/strategy-node-variable/${row.id}/${this.businessData.strategyId}`)
          if (res.code !== '200') {
            this.$message.error(res.message)
            return
          }
          this.loadEvaluations()
          this.$message.success('删除成功')
        } catch (ex) {
          console.info(ex)
          this.$message.error('删除失败')
        }
      }).catch(action => {
      })
    }),
    // ********************  分流  ***********************
    async loadShunts () {
      console.info('loadShunts', this.businessData)
      try {
        let params = {
          strategyId: this.businessData.strategyId,
          currentGraphicNodeId: this.businessData.graphicNodeId
        }
        let res = await this.$http.post(`/strategy-node-diversion/list`, params)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.shunts = res.data
        this.initBusinessShunts()
      } catch (ex) {
        console.info(ex)
        this.$message.error('获取策略节点变量失败')
      }
    },
    saveShunts: debounce(300, async function () {
      // 请求后端服务
      try {
        let checkRes = this.checkShunts()
        if (checkRes) {
          this.$message.error('分流条件数据不完整，请补充！')
          return
        }
        this.shunts.forEach((item, i) => {
          item.diversionSequence = i + 1
          item.diversionConditionExpression = this.convertToExpression(item.viewData)
          item.strategyRefVariables = this.getStrategyRefVariables(`shunt-${item.diversionGraphicNodeId}`, 3)
        })
        let res = await this.$http.post(`/strategy-node-diversion`, this.shunts)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.loadShunts()
        this.businessData.shunts = this.$utils.clone(this.shunts, true)
        this.saveNodesData()
        this.$message.success('保存成功')
      } catch (ex) {
        console.info(ex)
        this.$message.error('保存失败')
      }
    }),
    checkShunts () {
      const self = this
      return self.shunts.some((item, i) => self.shunts.length - 1 !== i && (item.viewData === null || item.viewData === ''))
    },
    initBusinessShunts () {
      this.nodeData.node.nextNodes.forEach(item => {
        let shunt = this.shunts.find(s => s.diversionGraphicNodeId && s.diversionGraphicNodeId === item.id)
        if (shunt) {
          if (!shunt.viewData || shunt.viewData === null) {
            shunt.viewData = ''
          }
        } else {
          this.shunts.unshift({
            strategyId: this.businessData.strategyId,
            currentGraphicNodeId: this.nodeData.node.id,
            currentGraphicNodeName: this.nodeData.node.code,
            diversionGraphicNodeId: item.id,
            diversionGraphicNodeCode: item.code,
            viewData: '',
            diversionConditionExpression: '',
            diversionSequence: 0,
            strategyRefVariables: []
          })
        }
      })
      if (this.shunts && this.shunts.length > 1) {
        this.setSort()
      }
      console.info('initBusinessShunts', this.shunts)
    },
    async loadNodeInfo () {
      console.info('loadNodeInfo', this.businessData)
      try {
        let params = {
          strategyId: this.businessData.strategyId,
          graphicNodeId: this.businessData.graphicNodeId
        }
        let res = await this.$http.post(`/strategy-node/detail`, params)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        return res.data
      } catch (ex) {
        console.info(ex)
        this.$message.error('获取策略节点详情失败')
      }
    },
    setSort () {
      let self = this
      this.$nextTick(() => {
        const el = document.querySelectorAll('#shuntsTable .el-table__body-wrapper > table > tbody')[0]
        Sortable.create(el, {
          ghostClass: 'sortable-ghost',
          onEnd: evt => {
            let targetList = self.$utils.clone(self.shunts, true)
            let targetRow = targetList.splice(evt.oldIndex, 1)[0]
            targetList.splice(evt.newIndex, 0, targetRow)
            self.shunts = []
            self.$nextTick(function () {
              targetList[targetList.length - 1].viewData = ''
              self.shunts = targetList
            })
          }
        })
      })
    },
    getExpression (viewData, variableName) {
      console.info('getExpression', viewData, variableName)
      let variable = this.variables.find(s => s.strategyId === this.businessData.strategyId && s.name === variableName &&
        s.dataType === 2)
      let result = variable ? viewData : (viewData.match(this.regex) || viewData.includes('$') ? viewData : `"${viewData}"`)
      let output = `{"s_${variableName}":${result}}`
      return this.convertToExpression(output)
    },
    convertToExpression (output) {
      console.info('convertToExpression', output)
      if (output) {
        output = output.replace(/@e./g, '').replace(/@m./g, 'm_').replace(/@s./g, 's_')
          .replace(/[$]max/g, this.mvelConfig.actionOptions.max).replace(/[$]min/g, this.mvelConfig.actionOptions.min)
      }
      return output
    },
    getStrategyRefVariables (refId, refSource) {
      let variables = []
      let mentionRef = this.$refs[refId]
      if (!mentionRef) {
        return variables
      }
      if (mentionRef instanceof Array) {
        mentionRef = mentionRef[0]
      }
      variables = mentionRef.targets.map(s => {
        return {
          refId: s.id,
          refVariableType: s.refType,
          name: s.name,
          strategyId: this.businessData.strategyId,
          refSource: refSource
        }
      })
      console.info('getStrategyRefVariables:targets:', variables)
      return variables
    },
    // ********************* 提供给父组件回调 ************************
    saveNodesData () {
      let node = this.$utils.clone(this.nodeData.node, true)
      let business = this.$utils.clone(this.businessData, true)
      this.$emit('saveNodesData', {node: node, business: business})
    }
  },
  components: {
    'el-editable': Editable,
    'el-editable-column': EditableColumn,
    TributeMention
  }
}
</script>
<style lang="stylus">
  .sortable-ghost{
    opacity: .8;
    color: #fff!important;
    background: #42b983!important;
    cursor: move;
  }
  .drag-handler{
    width: 20px;
    height: 20px;
    cursor: move;
  }
</style>



// WEBPACK FOOTER //
// src/views/decisionTree/middle-node-business.vue